import { apiCall } from './gqlClient';

const ATHLETEPBS_QUERY = `
  query athletePbs($userId: Float!, $exerciseId: String) {
    athletePbs(userId: $userId, exerciseId: $exerciseId)
    {
      id
			userId
			exerciseId
			activity
			valueNumeric
			valueText
			unit
			achievedDate
			notes
			dateCreated
      ...fragments
    }
  }`;

export const athletePbsApiCall = async ({userId, exerciseId}, fragments = null) => apiCall({ query: ATHLETEPBS_QUERY, variables: {userId, exerciseId}, fragments });

const CREATEATHLETEPB_QUERY = `
  mutation createAthletePb($input: AthletePbInput!) {
    createAthletePb(input: $input)
    {
      id
			userId
			exerciseId
			activity
			valueNumeric
			valueText
			unit
			achievedDate
			notes
			dateCreated
      ...fragments
    }
  }`;

export const createAthletePbApiCall = async ({input}, fragments = null) => apiCall({ query: CREATEATHLETEPB_QUERY, variables: {input}, fragments });

const DELETEATHLETEPB_QUERY = `
  mutation deleteAthletePb($id: String!) {
    deleteAthletePb(id: $id)
    {
      id
			userId
			exerciseId
			activity
			valueNumeric
			valueText
			unit
			achievedDate
			notes
			dateCreated
      ...fragments
    }
  }`;

export const deleteAthletePbApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEATHLETEPB_QUERY, variables: {id}, fragments });
